import {getCookie} from "../utils";
import {getRequest} from "./ApiService";

export function getExtraContents(){
    let candidateKey = getCookie("currentCandidate");
    return getRequest('extraContentList', {"candidateKey": candidateKey})
}
